export default "__VITE_ASSET__CoFsFsrw__"